module.exports = __webpack_public_path__ + "static/media/galleryImage03.05287bfe.jpg";